import {BooleanInput} from "react-admin";
import {Grid} from "@material-ui/core";
import React from "react";

function DepaBooleanInput(props) {
    return (
        <Grid xs={props.xs} sm={props.sm} md={props.md} lg={props.lg} xl={props.xl} item={props.item}>
            <BooleanInput source={props.source}
                       label={props.label}
                       type={props.type}
                       resettable={props.resettable}
                       multiline={props.multiline}
                       fullWidth={props.fullWidth}
                       validate={props.validate}
                       defaultValue={props.defaultValue}/>
        </Grid>
    )
}

DepaBooleanInput.defaultProps = {
    xl: false,
    lg: false,
    md: false,
    sm: false,
    xs: false,
    resettable: true,
    item: true,
    fullWidth: true,
    type: "text",
    multiline: false
}

export default DepaBooleanInput;